<template>
  <el-dialog
    title="部門匯出音檔清單"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                v-model="queryForm.qstr"
                placeholder="頻道名稱"
                style="width:180px"
              ></el-input>
            </el-form-item>

            <el-form-item label=" " label-width="15px">
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            @click="handleBatchExport"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次匯出</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-user" /> 部門名稱：{{ deptName }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="channels"
            v-loading="isLoading"
            ref="dataTable"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              type="index"
              :index="indexFormatter"
              prop="id"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="頻道名稱"
              prop="name"
              sortable="custom"
              width="250"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{
                  scope.row.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click="exportOneChannel(scope.row)"
                  >單頻道匯出
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>

          <!--<el-pagination-->
            <!--@size-change="handleSizeChange"-->
            <!--@current-change="handleCurrentChange"-->
            <!--:current-page.sync="currentPage"-->
            <!--:page-sizes="[50, 100, 200]"-->
            <!--:page-size="pageSize"-->
            <!--layout="total, sizes, prev, pager, next, jumper"-->
            <!--:total="total" >-->
          <!--</el-pagination>-->

        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import tagColorsMixin from "@/components/mixin/tagColors.js";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  components: {},

  model: {
    prop: "visible",
    event: "toggleVisible",
  },

  created() {
    this.sort = this.defaultSortCol;
    this.order = this.defaultOrder;
    if (this.innerVisible) {
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    }
  },

  props: {
    visible: {
      type: Boolean,
    },
    deptId: {
      type: Number,
    },
    deptName: {
      type: String,
    },
  },

  data() {
    return {
      channels: [],
      total: 0,
      offset: 0,
      sort: "",
      order: "descending",

      selectedRow: [],
      isLoading: false,
      defaultSortCol: "name",
      defaultOrder: "ascending",
      //pageSize: 50,
      pageSize: 99999, //no pagination for now
      currentPage: 1,
      queryForm: {
        qstr: "",
        //colors: [],
      },
      activeQueryForm: {
        qstr: "",
        //colors: [],
      },
    };
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },

  methods: {
    exportOneChannel(row, ) {
      const chnIds = [row.id];
      this.exportSelectedChannels(chnIds, );
    },

    exportSelectedChannels(ids, ) {
      const baseURL = process.env.VUE_APP_APIURL?process.env.VUE_APP_APIURL:(window.location.origin.replace('//admin.','//api.')+"/");
      let apiUrl = `${baseURL}channel/export/?token=${encodeURI(this.$store.state.auth.access_token)}`;
      ids.forEach(id => {
        apiUrl += `&channels=${id}`
      })

      const link = document.createElement("a");
      link.href = apiUrl;
      link.setAttribute("type", "hidden");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleBatchExport() {
      const ids = this.selectedRow.map(row => row.id);
      this.exportSelectedChannels(ids);
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.isLoading = true;
      this.query(
        this.pageSize,
        0,
        this.sort,
        this.order,
        this.activeQueryForm
      ).then(() => (this.isLoading = false));
    },

    //handleSizeChange(val) {
      //this.pageSize = val;
      //this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    //},

    //handleCurrentChange(page) {
      //this.query(
        //this.pageSize,
        //this.pageSize * (page - 1),
        //this.sort,
        //this.order,
        //this.activeQueryForm
      //);
    //},

    query(max, offset, sort, order, params) {
      const newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        dept: this.deptId,
        ...params,
      };

      return API.channel
        .list(newParams)
        .then(res => {
          if (res.status === 200) {
            this.channels = res.data[0];
            this.total = res.data[1];
            this.offset = offset;
            return res;
          } else {
            return Promise.reject(res);
          }
        })
        .finally(() => {
        });
    },

    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },

    sortChange(args) {
      if (args.order === null) {
        this.sort = this.defaultSortCol;
        this.order = this.defaultOrder;
      } else {
        this.sort = args.prop;
        this.order = args.order;
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {},
  },
};
</script>

<style scoped>
.phoneicon {
  width: 28px;
  height: 28px;
  margin-left: -5px;
  margin-right: 2px;
}
.personicon {
  width: 24px;
  height: 24px;
  margin-left: 2px;
  margin-right: 2px;
}
.groupicon {
  width: 28px;
  height: 28px;
  margin-left: 0px;
  margin-right: 2px;
}
</style>
